import React from 'react'
import { CommonLabel as Label } from '@/components/ui/common-label'
import { cn } from '@/lib/utils'
import { ArrowUpCircle, ArrowDownCircle } from 'lucide-react'
import { Button } from '@/components/ui/button'

const DashboardHeaderCard = ({ 
  name, 
  count, 
  unit, 
  percentage, 
  isIncreased, 
  icon, 
  differenceText 
}) => {
  const IconButton = ({ children, className, ...props }) => (
    <Button variant="none" size="icon" className={className} {...props}>
      {children}
    </Button>
  )

  return (
  <div className="border border-border p-0.5 rounded-[16px] bg-card w-full transition-all transform" style={{boxShadow: '0px 2px 10px 0px hsl(var(--border) / 0.1)'}}>
      <div className="border border-border px-3 py-2 rounded-[16px] bg-background flex justify-between items-center">
        <div className="space-y-1">
          <Label size="xs" weight="medium" className="text-muted-foreground">
            {name}
          </Label>

          <div className="flex items-center gap-2">
            <Label size="lg" weight="bold">
              {` ${count}  ${unit ? unit : ""}`}
            </Label>

            {percentage && (
              <div
                className={cn(
                  "flex items-center gap-1 bg-primary/20 text-primary rounded-full px-1.5 py-0.5",
                  !isIncreased && "text-error bg-error/20"
                )}
              >
                {isIncreased ? <ArrowUpCircle size={18} /> : <ArrowDownCircle size={18} />}
                <Label size="xs">{`${percentage}%`}</Label>
              </div>
            )}
          </div>
        </div>

        <IconButton className="rounded-[13px] shadow-[0px_4.9px_19.6px_0px_hsl(var(--border)_/_0.2)] border border-border hover:cursor-default active:scale-100 hover:scale-none">
          {icon}
        </IconButton>
      </div>

      {differenceText && (
        <div className="flex items-center justify-between px-3 py-1">
          <div className="flex items-center gap-1">
            <Label size="xs" weight="bold" className="text-foreground">
              {differenceText.split(' ')[0]}
            </Label>
            <Label size="xs" className="text-muted-foreground">
              {differenceText.split(' ').slice(1).join(' ')}
            </Label>
          </div>
        </div>
      )}
    </div>
  )
}

export default DashboardHeaderCard